import React, { useEffect } from 'react';

// Генерируем список годов (от 1900 до текущего года)
const generateYears = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear; year >= 1900; year--) {
    years.push(year);
  }
  return years;
};

const YearPickerModal = ({ 
  showYearPicker, 
  selectYear, 
  closeYearPicker,
  activeYearItemId,
  modalData
}) => {
  // Эффект для прокрутки к текущему году при открытии календаря
  useEffect(() => {
    if (showYearPicker) {
      const timer = setTimeout(() => {
        const currentYear = new Date().getFullYear();
        const years = generateYears();
        const currentYearIndex = years.findIndex(year => year === currentYear);
        
        if (currentYearIndex >= 0) {
          const currentYearElement = document.querySelector(`.year-picker-list li:nth-child(${currentYearIndex + 1})`);
          if (currentYearElement) {
            currentYearElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [showYearPicker]);

  // Закрытие по Escape
  useEffect(() => {
    if (!showYearPicker) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeYearPicker();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [showYearPicker, closeYearPicker]);

  if (!showYearPicker) return null;

  return (
    <div className="picker-overlay" onClick={closeYearPicker}>
      <div className="picker-modal" onClick={(e) => e.stopPropagation()}>
        <div className="picker-header">
          <h3>Выберите год</h3>
          <button className="picker-close" onClick={closeYearPicker}>×</button>
        </div>
        
        <div className="picker-content">
          <ul className="picker-list year-picker-list" style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {generateYears().map((year) => {
              const currentYear = new Date().getFullYear();
              const isCurrentYear = year === currentYear;
              const isSelected = activeYearItemId && modalData && modalData.find(item => item.id === activeYearItemId)?.godpovr === year.toString();
              
              return (
                <li
                  key={year}
                  className={`picker-item ${isSelected ? 'selected' : ''} ${isCurrentYear ? 'current-year' : ''}`}
                  onClick={() => selectYear(year)}
                  style={{
                    padding: '8px 12px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #eee',
                    backgroundColor: isCurrentYear && !isSelected ? '#e8f4fd' : 'transparent'
                  }}
                >
                  <div style={{ 
                    fontWeight: '500',
                    color: isCurrentYear ? '#1976d2' : 'inherit'
                  }}>
                    {year} {isCurrentYear ? '(текущий)' : ''}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default YearPickerModal;

